/**
 * Ambient brand videos (.project-video, .mhb__asset):
 * - Try unmuted autoplay on the visible video only (fall back to muted)
 * - Pause + silence hidden desktop/mobile siblings so tab audio cannot leak
 * - Mute/unlock helpers keep sibling audio state in sync
 * No center Enable Sound CTA.
 */
(function () {
  if (window.__laboAmbientVideoSound) return;
  window.__laboAmbientVideoSound = true;

  var SELECTOR = 'video.project-video, video.mhb__asset';
  var syncing = false;
  var pendingRetry = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  var audibleInflight = typeof WeakSet !== 'undefined' ? new WeakSet() : null;

  function injectStyles() {
    if (document.getElementById('labo-ambient-sound-styles')) return;
    var style = document.createElement('style');
    style.id = 'labo-ambient-sound-styles';
    style.textContent =
      '.ambient-av-wrap,.ios-av-wrap{position:relative;width:100%;height:100%}' +
      '.ambient-av-wrap>video,.ios-av-wrap>video{width:100%}' +
      '@media screen and (max-width:749px){' +
      '.ambient-av-wrap:has(>video.project-video-desktop),' +
      '.ios-av-wrap:has(>video.project-video-desktop){display:none!important}' +
      '}' +
      '@media screen and (min-width:750px){' +
      '.ambient-av-wrap:has(>video.project-video-mobile),' +
      '.ios-av-wrap:has(>video.project-video-mobile){display:none!important}' +
      '}';
    document.head.appendChild(style);
  }

  function allAmbient() {
    return Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
  }

  function siblingGroup(video) {
    var host = video.closest(
      '.projects-vid, media-heading-banner, .mhb, .swiper-slide'
    );
    if (!host) return [video];
    var group = Array.prototype.slice.call(host.querySelectorAll(SELECTOR));
    return group.length ? group : [video];
  }

  // True when CSS (device breakpoint / slide) intentionally hides the node.
  function isCssHidden(el) {
    if (!el || !el.isConnected) return true;
    var node = el;
    while (node && node.nodeType === 1) {
      var style = window.getComputedStyle(node);
      if (style.display === 'none' || style.visibility === 'hidden') return true;
      if (node === document.documentElement) break;
      node = node.parentElement;
    }
    return false;
  }

  function hasLayout(el) {
    if (!el || !el.isConnected) return false;
    var rect = el.getBoundingClientRect();
    return rect.width > 1 && rect.height > 1;
  }

  function isVisiblyRendered(el) {
    return !isCssHidden(el) && hasLayout(el);
  }

  function silenceVideo(video) {
    if (!video) return;
    try {
      video.defaultMuted = true;
    } catch (e) {}
    video.muted = true;
    video.setAttribute('muted', '');
    // Do not set volume=0 — native controls treat volume===0 as muted even when unmuted later.
  }

  // Keep muted property, attribute, defaultMuted, and volume aligned for native/custom mute icons.
  function applyUnmutedState(video) {
    if (!video) return;
    try {
      video.defaultMuted = false;
    } catch (e) {}
    video.muted = false;
    video.removeAttribute('muted');
    try {
      if (typeof video.volume === 'number' && video.volume < 0.05) {
        video.volume = 1;
      }
    } catch (e2) {}
  }

  function pauseAndSilence(video) {
    if (!video) return;
    try {
      video.pause();
    } catch (e) {}
    silenceVideo(video);
  }

  function copyDeviceClass(video, wrap) {
    if (video.classList.contains('project-video-desktop')) {
      wrap.classList.add('project-video-desktop');
    }
    if (video.classList.contains('project-video-mobile')) {
      wrap.classList.add('project-video-mobile');
    }
  }

  function ensureWrap(video) {
    var existing = video.closest('.ios-av-wrap, .ambient-av-wrap');
    if (existing) return existing;
    var parent = video.parentElement;
    if (!parent) return null;
    var wrap = document.createElement('div');
    wrap.className = 'ambient-av-wrap';
    copyDeviceClass(video, wrap);
    parent.insertBefore(wrap, video);
    wrap.appendChild(video);
    return wrap;
  }

  function unlockSound(video) {
    if (video) {
      delete video.dataset.ambientUserMuted;
      delete video.dataset.ambientAudibleOutcome;
    }
    syncing = true;
    try {
      siblingGroup(video).forEach(function (v) {
        if (v !== video) pauseAndSilence(v);
      });
    } finally {
      syncing = false;
    }

    applyUnmutedState(video);
    try {
      video.volume = 1;
    } catch (e) {}

    var playResult = video.play();
    if (playResult && typeof playResult.then === 'function') {
      return playResult.then(
        function () {
          if (!video.muted) applyUnmutedState(video);
          return !video.muted;
        },
        function () {
          return !video.muted;
        }
      );
    }
    return Promise.resolve(!video.muted);
  }

  function muteSound(video) {
    if (video) video.dataset.ambientUserMuted = '1';
    // Mute the whole sibling group so no hidden copy keeps tab audio alive.
    siblingGroup(video).forEach(silenceVideo);
  }

  window.laboAmbientUnlockSound = unlockSound;
  window.laboAmbientMuteSound = muteSound;

  function markInflight(video, on) {
    if (!audibleInflight || !video) return;
    if (on) audibleInflight.add(video);
    else audibleInflight.delete(video);
  }

  function isInflight(video) {
    return !!(audibleInflight && video && audibleInflight.has(video));
  }

  function tryAudibleAutoplay(video) {
    if (!video || !video.isConnected) return;
    if (video.dataset.ambientUserMuted === '1') return;
    if (video.dataset.ambientAudibleOutcome === 'blocked') return;
    if (isCssHidden(video)) {
      pauseAndSilence(video);
      return;
    }
    if (!hasLayout(video)) {
      scheduleAudibleAutoplay(video);
      return;
    }
    if (isInflight(video)) return;

    // Silence hidden siblings without cascading mute back onto this video.
    syncing = true;
    try {
      siblingGroup(video).forEach(function (v) {
        if (v !== video) pauseAndSilence(v);
      });
    } finally {
      syncing = false;
    }

    applyUnmutedState(video);
    try {
      video.volume = 1;
    } catch (e) {}

    markInflight(video, true);
    var playResult = video.play();
    if (!playResult || typeof playResult.then !== 'function') {
      markInflight(video, false);
      if (!video.muted) {
        video.dataset.ambientAudibleOutcome = 'allowed';
        applyUnmutedState(video);
      } else {
        video.dataset.ambientAudibleOutcome = 'blocked';
      }
      return;
    }

    playResult.then(
      function () {
        markInflight(video, false);
        // play() can resolve while still muted (browser remuted) — treat as policy block.
        if (video.muted) {
          video.dataset.ambientAudibleOutcome = 'blocked';
          syncing = true;
          try {
            silenceVideo(video);
          } finally {
            syncing = false;
          }
          return;
        }
        video.dataset.ambientAudibleOutcome = 'allowed';
        applyUnmutedState(video);
      },
      function () {
        markInflight(video, false);
        // Browser blocked audible autoplay — muted fallback (icon correctly muted).
        video.dataset.ambientAudibleOutcome = 'blocked';
        syncing = true;
        try {
          silenceVideo(video);
        } finally {
          syncing = false;
        }
        video.play().catch(function () {});
      }
    );
  }

  window.laboAmbientTryAudible = tryAudibleAutoplay;

  function scheduleAudibleAutoplay(video) {
    if (!video || !video.isConnected) return;
    if (video.dataset.ambientUserMuted === '1') return;
    if (isCssHidden(video)) {
      pauseAndSilence(video);
      return;
    }
    if (isVisiblyRendered(video)) {
      tryAudibleAutoplay(video);
      return;
    }
    if (pendingRetry && pendingRetry.has(video)) return;
    if (pendingRetry) pendingRetry.add(video);

    var tries = 0;
    function tick() {
      if (!video.isConnected) {
        if (pendingRetry) pendingRetry.delete(video);
        return;
      }
      if (video.dataset.ambientUserMuted === '1') {
        if (pendingRetry) pendingRetry.delete(video);
        return;
      }
      if (isCssHidden(video)) {
        pauseAndSilence(video);
        if (pendingRetry) pendingRetry.delete(video);
        return;
      }
      if (hasLayout(video)) {
        if (pendingRetry) pendingRetry.delete(video);
        tryAudibleAutoplay(video);
        return;
      }
      tries += 1;
      if (tries < 45) {
        requestAnimationFrame(tick);
      } else if (pendingRetry) {
        pendingRetry.delete(video);
      }
    }
    requestAnimationFrame(tick);
  }

  function syncHiddenVideos() {
    if (syncing) return;
    syncing = true;
    try {
      allAmbient().forEach(function (video) {
        if (isCssHidden(video)) {
          pauseAndSilence(video);
        }
      });
    } finally {
      syncing = false;
    }
  }

  // Full pass: clear prior policy outcome so newly visible videos can retry audible.
  function syncVisibilityAndSound() {
    syncHiddenVideos();
    allAmbient().forEach(function (video) {
      if (isCssHidden(video)) return;
      delete video.dataset.ambientAudibleOutcome;
      scheduleAudibleAutoplay(video);
    });
  }

  // Resize: do not re-fight a known policy block; still finish deferred layout attempts.
  function onResize() {
    syncHiddenVideos();
    allAmbient().forEach(function (video) {
      if (isCssHidden(video)) return;
      if (video.dataset.ambientAudibleOutcome === 'allowed') {
        if (!video.muted) applyUnmutedState(video);
        return;
      }
      if (video.dataset.ambientAudibleOutcome === 'blocked') return;
      scheduleAudibleAutoplay(video);
    });
  }

  function bindSync(video) {
    if (video.dataset.ambientSoundBound === '1') return;
    video.dataset.ambientSoundBound = '1';

    video.addEventListener('volumechange', function () {
      if (syncing) return;
      if (!video.muted) {
        delete video.dataset.ambientUserMuted;
        applyUnmutedState(video);
        return;
      }
      // Only cascade when the *visible* video is muted (user/control mute).
      if (!isVisiblyRendered(video)) return;
      video.dataset.ambientUserMuted = '1';
      syncing = true;
      try {
        siblingGroup(video).forEach(function (v) {
          if (v !== video) silenceVideo(v);
        });
      } finally {
        syncing = false;
      }
    });

    video.addEventListener('playing', function () {
      if (syncing) return;
      if (isCssHidden(video)) return;
      if (video.dataset.ambientUserMuted === '1') return;
      if (!video.muted) {
        video.dataset.ambientAudibleOutcome = 'allowed';
        applyUnmutedState(video);
        return;
      }
      // Playing muted after HTML/CE autoplay — retry audible once (not after policy block).
      if (video.dataset.ambientAudibleOutcome === 'blocked') return;
      if (video.dataset.ambientAudibleOutcome === 'allowed') return;
      scheduleAudibleAutoplay(video);
    });

    video.addEventListener('pause', function () {
      if (syncing) return;
      siblingGroup(video).forEach(function (v) {
        if (v !== video && isCssHidden(v)) {
          pauseAndSilence(v);
        }
      });
    });
  }

  function isIosWebKit() {
    if (typeof window.laboAmbientIsIosWebKit === 'function') {
      return window.laboAmbientIsIosWebKit();
    }
    var ua = navigator.userAgent || '';
    var iOS =
      /iPhone|iPad|iPod/i.test(ua) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    return iOS && /AppleWebKit/i.test(ua);
  }

  function enhance(video) {
    if (!video || video.dataset.ambientSound === '1') return;
    video.dataset.ambientSound = '1';

    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    // Desktop/Android: keep native controls (Chrome-like).
    // iOS WebKit: ios-safari-ambient-video.js strips native controls (system dim)
    // and mounts a Chrome-equivalent custom bar — do not leave controls=true on iOS.
    if (isIosWebKit()) {
      video.controls = false;
      video.removeAttribute('controls');
    } else {
      video.controls = true;
      video.setAttribute('controls', '');
    }

    var wrap = ensureWrap(video);
    if (!wrap) return;

    var leftover = wrap.querySelector('.ambient-sound-cta');
    if (leftover) leftover.remove();

    bindSync(video);
    scheduleAudibleAutoplay(video);
  }

  function enhanceAll() {
    injectStyles();
    document.querySelectorAll(SELECTOR).forEach(enhance);
    syncVisibilityAndSound();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceAll);
  } else {
    enhanceAll();
  }

  window.addEventListener('load', syncVisibilityAndSound);
  window.addEventListener('resize', onResize);
  if (window.matchMedia) {
    try {
      window.matchMedia('(min-width: 750px)').addEventListener('change', function () {
        syncVisibilityAndSound();
      });
    } catch (e) {}
  }
})();
